import { render, staticRenderFns } from "./feedback_hub.vue?vue&type=template&id=575f1939&"
import script from "./feedback_hub.vue?vue&type=script&lang=js&"
export * from "./feedback_hub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports